import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'makeColorDarker' })
export class MakeColorDarkerPipe implements PipeTransform {
  transform(colorInHex: string, minLighting = 150, amt = -55) {
    return this.checkColorLighting(colorInHex, minLighting, amt);
  }

  public checkColorLighting(color, minLighting, amt) {
    const c = color.substring(1); // strip #
    const rgb = parseInt(c, 16); // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff; // extract red
    const g = (rgb >> 8) & 0xff; // extract green
    const b = (rgb >> 0) & 0xff; // extract blue
    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
    if (luma > minLighting) {
      // pick a different colour
      return this.lightenDarkenColor(color, amt);
    }
    return color;
  }

  // https://css-tricks.com/snippets/javascript/lighten-darken-color/
  lightenDarkenColor(col, amt) {
    let usePound = false;

    if (col[0] == '#') {
      col = col.slice(1);
      usePound = true;
    }

    const num = parseInt(col, 16);

    let r = (num >> 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    let b = ((num >> 8) & 0x00ff) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    let g = (num & 0x0000ff) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
  }
}
